module.exports = __webpack_public_path__ + "static/media/20171027_183336.2086deab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20171027_183336.jpg
// module id = 473
// module chunks = 0